module.exports = __webpack_public_path__ + "static/carepath-logo-fr-faf81a59d542b80e50c38d3bb674fd96.png";